import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionContext } from 'src/app/core/services/config/app.settings';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { NgClass, DOCUMENT } from '@angular/common';
import { usePreset } from '@primeuix/themes';
import { AnppPreset } from '../../../../assets/themes/anpp.preset';
import { VinPreset } from '../../../../assets/themes/vin.preset';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [HeaderComponent, MenuComponent, RouterOutlet, NgClass],
    standalone: true
})
export class MainComponent implements OnInit {
    /**
     * True if ANPP, false otherwise
     */
    isAnpp = false;

    /**
     * Dependency injections
     */
    private readonly renderer = inject(Renderer2);
    private readonly document = inject(DOCUMENT);

    /**
     * Getter for displayPage
     */
    public get displayPage() {
        return window.location.pathname !== '/main';
    }

    /**
     * On init component
     */
    ngOnInit() {
        const codeDomaine = SessionContext.get('codeDomaine');
        this.isAnpp = codeDomaine === 'ANPP';

        if (this.isAnpp) {
            this.renderer.addClass(this.document.body, 'anpp');
            this.renderer.removeClass(this.document.body, 'vin');
            usePreset(AnppPreset);
        } else {
            this.renderer.addClass(this.document.body, 'vin');
            this.renderer.removeClass(this.document.body, 'anpp');
            usePreset(VinPreset);
        }
    }
}
